import { VStack, Text, Button, HStack } from '@chakra-ui/react';
import { useParams, useNavigate } from 'react-router';
import { useMfa } from '../../context/MfaContext';
import { useMfaApi } from '../../hooks/useMfaApi';
import { useMfaToast } from '../../hooks/useMfaToast';
import { ArrowBackIcon } from '@chakra-ui/icons';
import MfaSetUpTotp from '../../components/client/account/MfaSetUpTotp';
import MfaSetUpEmail from '../../components/client/account/MfaSetUpEmail';

function MfaMethodSetUpPage() {
  const { type } = useParams();
  const navigate = useNavigate();
  const { mfaMethod, otpSecret, clearMfaSetup, isSettingUp } = useMfa();
  const { revertOtpSetup } = useMfaApi();
  const { showErrorToast } = useMfaToast();

  const handleBack = async () => {
    try {
      if (isSettingUp && mfaMethod && otpSecret) {
        await revertOtpSetup(mfaMethod, otpSecret);
      }
      clearMfaSetup();
      navigate('/mfa');
    } catch (error) {
      console.error('Error reverting MFA setup:', error);
      showErrorToast('Error reverting MFA setup', 'Please try again');
      clearMfaSetup();
      navigate('/mfa');
    }
  };

  return (
    <>
      <HStack w="full" justifyContent="flex-start" alignItems="center" mb={6}>
        <Button
          leftIcon={<ArrowBackIcon />}
          variant="ghost"
          onClick={handleBack}
          size="sm"
          p={0}
        >
          Back
        </Button>
      </HStack>
      {type === 'totp' ? (
        <VStack mb={6} alignItems="flex-start">
          <Text textStyle="heading2">Authenticator app</Text>
          <MfaSetUpTotp />
        </VStack>
      ) : (
        <VStack alignItems="flex-start">
          <Text textStyle="heading2">E-mail verification</Text>
          <MfaSetUpEmail />
        </VStack>
      )}
    </>
  );
}

export default MfaMethodSetUpPage;
